/* eslint-disable */
// import moment from 'moment'

var isIE = !!window.ActiveXObject || 'ActiveXObject' in window

// readAsBinaryString polyfill
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function(fileData) {
    var binary = ''
    var pk = this
    var reader = new FileReader()
    reader.onload = function(e) {
      var bytes = new Uint8Array(reader.result)
      var length = bytes.length

      for (var i = 0; i < length; i++) {
        var a = bytes[i]
        var b = String.fromCharCode(a)
        binary += b
      }
      pk.content = binary
      pk.onload(pk)
    }
    reader.readAsArrayBuffer(fileData)
  }
}

if (isIE) {
  var getBlobWithHref = function(url, cb) {
    try {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response)
        }
      }
      xhr.send()
    } catch (e) {
      // ignore
    }
  }
  
  // IE a 标签不支持 download 属性，在这里拦截然后下载文件
  document.addEventListener('click', function(e) {
    var target = e.target;
    // Link标签测试环境和本地环境渲染的结果不一样
    var parentNode = target.parentNode;
    if (parentNode.tagName.toUpperCase() === 'A' && target.tagName.toUpperCase() === 'SPAN') {
      target = parentNode
    }
    if (target.tagName.toUpperCase() === 'A') {
      var hasDownloadAttr = target.hasAttribute('download')
      var hasDisabledAttr = target.hasAttribute('disabled')
      if (hasDisabledAttr) {
        e.preventDefault()
        // 阻止 click 事件执行
        e.stopImmediatePropagation()
      }
      var href = target.getAttribute('href')
      if (href && hasDownloadAttr) {
        var strs = href.split('/')
        var fileName = strs[strs.length - 1]
        getBlobWithHref(href, function(blob) {
          window.navigator.msSaveBlob(blob, fileName)
        })
        e.preventDefault()
        e.stopPropagation()
      }
    }
  }, false)
}